import * as ActionTypes from 'state/types'
import * as Selectors from 'state/selectors'
import Routes from 'shared/utils/api/routes'

export const catchApiError = error => ({
  type: ActionTypes.CATCH_API_ERROR,
  error
})

export const authCheck = () => ({
  type: ActionTypes.AUTH_CHECK_SESSION
})

export const selectFilter = filter => ({
  type: ActionTypes.CONSISTENT_MULTIPLE_ACTIONS,
  payload: {
    actions: [
      {
        type: ActionTypes.SELECT_FILTER,
        payload: {
          filter
        }
      },
      {
        type: ActionTypes.INTERACTIONS_LIST_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.INTERACTIONS_LIST_ROUTE,
          method: 'get',
          params: {
            page: 1
          },
          unique: true
        },
        selectorsToPayload: [
          {
            selector: Selectors.getSelectedInbox,
            deepLevel: ['params'],
            key: 'inbox'
          },
          {
            selector: Selectors.getSelectedFilter,
            deepLevel: ['params'],
            key: 'filter'
          }
        ]
      }
    ]
  }
})
